import { Link } from 'react-router-dom';
import React, { useState, useEffect } from 'react';

import Box from '@mui/material/Box';
import Table from '@mui/material/Table';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import TableBody from '@mui/material/TableBody';
import TableHead from '@mui/material/TableHead';
import Typography from '@mui/material/Typography';
import TableContainer from '@mui/material/TableContainer';

const DeviceList = ({ devices }) => {
  const [rows, setRows] = useState([]);

  useEffect(() => {
    if (devices && devices.length) {
      setRows(devices.map(each => each));
    }
  }, [devices]);

  if (!rows.length) {
    return (
      <Box
        sx={{ width: '100%', boxShadow: 1, borderRadius: 1, p: 4 }}
        display="flex"
        justifyContent="center"
        flexDirection="column"
        alignItems="center"
      >
        <Typography variant="h6" gutterBottom component="div">
          Devices not available
        </Typography>
      </Box>
    );
  }

  return (
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 650 }} stickyHeader>
        <TableHead>
          <TableRow>
            <TableCell>ICCID</TableCell>
            <TableCell align="left">Status</TableCell>
            <TableCell align="left">Rate Plan</TableCell>
            <TableCell align="left">Usage</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map(row => (
            <TableRow
              key={row.iccid}
              sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
            >
              <TableCell component="th" scope="row">
                <Link to={`${row.iccid}`}>
                  <Button size="small">{row.iccid}</Button>
                </Link>
              </TableCell>
              <TableCell>{row.status}</TableCell>
              <TableCell>{row.rate_plan}</TableCell>
              <TableCell>{row.cycle_data_usage}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default DeviceList;
